/* eslint-disable import/no-cycle */
import { createApi } from '@reduxjs/toolkit/query/react';

import BaseService from './BaseService';

const axiosBaseQuery = () => async (request) => {
  try {
    const response = await BaseService(request);
    return response;
  } catch (axiosError) {
    const err = axiosError;
    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message
      }
    };
  }
};

const RtkQueryService = createApi({
  reducerPath: 'rtkApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'Activities',
    'Activity',
    'ActivitySubmissions',
    'Deliverables',
    'Modules',
    'Module',
    'ModuleBySlug',
    'Courses',
    'Course',
    'CourseModules',
    'CoursePreview',
    'CourseEnrollmentStats',
    'CourseLearners',
    'Lesson',
    'UniversityAdminsById',
    'SingleCohort',
    'University',
    'Thread',
    'Comment',
    'UnreadTotal',
    'BoardUnread',
    'SharingPlatforms',
    'SharingPlatform',
    'SharingPlatformPublic',
    'NotificationPreferences',
    'AdminAgentHealth',
    'AdminAgentTools',
    'AdminUserSearch',
    'AdminAuditLog',
    'Quizzes',
    'Billing',
    'LearnerGoal',
    'GoalsAdmin',
    'LearnerVisibility',
    'LearnerCourseProgress',
    'AssistantStatus'
  ],
  endpoints: () => ({})
});

export default RtkQueryService;
